/**
 * Thin compatibility shim over the shared auth module (src/auth/tokenService)
 * so existing shell imports keep compiling. New code should import
 * tokenService directly.
 */
import * as tokenService from "./tokenService";

export { ACCESS_TOKEN_COOKIE, REFRESH_TOKEN_COOKIE } from "./tokenService";
export type { TokenPayload, SessionConfig } from "./tokenService";

export const setTokens = tokenService.setTokens;

/** Legacy shell semantics: returns the access_token STRING. */
export const getAccessToken = (): string | undefined =>
  tokenService.getAccessToken()?.access_token;

export const isAuthenticated = tokenService.isAuthenticated;

export const clearTokens = () => {
  tokenService.clearTokens();
  localStorage.removeItem("loginMethod");
};
